import { CHANGE_LOCALE } from './types';

export const changeLocale = (locale, selectedLanguage) => dispatch => {
  dispatch({
    type: CHANGE_LOCALE,
    payload: { locale: locale, selectedLanguage: selectedLanguage }
  });
};
